import React from 'react';
import { Switch } from 'antd';
import { CustomComponentProps } from '../types';

/**
 * Custom Switch wrapper component
 */
export interface MySwitchProps extends CustomComponentProps {
  checkedChildren?: React.ReactNode;
  unCheckedChildren?: React.ReactNode;
  size?: 'small' | 'default';
}

const MySwitch: React.FC<MySwitchProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  checkedChildren,
  unCheckedChildren,
  size = 'default',
  ...rest
}) => {
  const handleChange = (checked: boolean) => {
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <Switch
      checked={value}
      onChange={handleChange}
      disabled={disabled || readonly}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
      size={size}
      {...rest}
    />
  );
};

export default MySwitch;
